/**
 * AbilityStun.js
 * Implements the Stun/Jam ability
 */

import { Game, GameTimer } from "pixi_core";

import { Ability } from "./Ability";
import { Common } from "../Common";

import {
    shuffle,
    GameEvents,
    ENEMY_ABILITY_PARTICLE_HERO_TARGET_X,
    ENEMY_ABILITY_PARTICLE_HERO_TARGET_Y,
    ENEMY_ABILITY_PARTICLE_TRAVEL_TIME
} from "../../Constants";

export class AbilityStun extends Ability {
    /**
     * @public
     * @param {Number} nbHeroes
     * @param {Number} nbTurns
     * @param {{x: Number, y: Number}} startPos
     * @param {Function} callback
     */
    constructor(nbHeroes, nbTurns, startPos, callback) {
        super();

        const stunnedHeroes = [false, false, false, false];
        const randomIndices = shuffle([0, 1, 2, 3]);

        for (let i = 0; i < nbHeroes; ++i) {
            stunnedHeroes[randomIndices[i]] = true;

            const targetX = ENEMY_ABILITY_PARTICLE_HERO_TARGET_X;
            const targetY = ENEMY_ABILITY_PARTICLE_HERO_TARGET_Y[randomIndices[i]];
            Common.particles.createEnemyAbilityParticle(startPos.x, startPos.y, targetX, targetY, null);
        }

        const delay = startPos ? ENEMY_ABILITY_PARTICLE_TRAVEL_TIME : 0;

        /** @private @type {GameTimer} */
        this._timerParticlesDelay = Game.windows.getCurrentWindow().createTimer(delay);
        this._timerParticlesDelay.onComplete = () => {
            Game.fire(GameEvents.eHEROES_STUNNED, stunnedHeroes, nbTurns);

            if (callback) {
                callback();
            }
        };
    }

    /**
     * @public
     */
    destroy() {
        if (this._timerParticlesDelay) {
            this._timerParticlesDelay.destroy();
            this._timerParticlesDelay = null;
        }
    }
}
